export default __webpack_public_path__ + "static/media/TopBarNotification.98fa2503.svg";